import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { SupplierImporterPage } from '@/areas/suppliers/Suppliers/SupplierImporterPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/suppliers/importer')({
    staticData: {
        access: { permissions: ['view:supplier', 'create:supplier'] },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <SupplierImporterPage />;
}
